import {OverlayModule} from "@angular/cdk/overlay";
import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {ButtonModule} from "@app/presentation/components/button/button.module";
import {TranslateModule} from "@ngx-translate/core";
import {
  DropdownQuantitySelectorComponent
} from "@app/presentation/components/cart-line-quantity-setter/dropdown-quantity-selector/dropdown-quantity-selector.component";
import {ReactiveFormsModule} from "@angular/forms";
import {LocalizedCurrencyModule} from "@app/presentation/pipes/localized-currency/localized-currency.module";
import {FormFieldModule} from "@app/presentation/components/form-field/form-field.module";
import {RadioButtonModule} from "@app/presentation/components/radio-button/radio-button.module";
import {AppBarModule} from "@app/presentation/components/app-bar/app-bar.module";
import {AngularSvgIconModule} from "angular-svg-icon";
import {CartLineQuantitySetterComponent} from './cart-line-quantity-setter.component';


@NgModule({
  declarations: [
    CartLineQuantitySetterComponent,
    DropdownQuantitySelectorComponent,
  ],
  imports: [
    CommonModule,
    AngularSvgIconModule,
    ButtonModule,
    TranslateModule,
    OverlayModule,
    ReactiveFormsModule,
    LocalizedCurrencyModule,
    FormFieldModule,
    RadioButtonModule,
    AppBarModule
  ],
  exports: [
    CartLineQuantitySetterComponent,
  ]
})
export class CartLineQuantitySetterModule { }
